import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CtrlKeyService {
  public isCtrlHeld = signal(false);
}
